import { render, staticRenderFns } from "./modalRegistrarPago.vue?vue&type=template&id=19000f68&scoped=true&"
import script from "./modalRegistrarPago.vue?vue&type=script&lang=js&"
export * from "./modalRegistrarPago.vue?vue&type=script&lang=js&"
import style0 from "./modalRegistrarPago.vue?vue&type=style&index=0&id=19000f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19000f68",
  null
  
)

export default component.exports